import React from "react";
import AIToolsBlock from "../../components/AIToolsBlock";
import { getGenerateCharterPrompt } from "./ai-prompts";

const AIPrompt1Block = () => (
  <AIToolsBlock
    title="Herramientas de IA para el Paso 1"
    subtitle="Usa este prompt para generar el borrador del charter a partir del requerimiento."
    prompts={[getGenerateCharterPrompt()]}
  />
);

export default AIPrompt1Block;
